'use client';
import { jsxs as m, jsx as o } from "react/jsx-runtime";
import { Icon as p } from "@tameeni/icons";
import { cn as v } from "@tameeni/shared-logic";
import k, { useMemo as N, useCallback as c } from "react";
import { Button as x } from "../button/button.js";
import C from "../input/input-variants.js";
const I = ({
  onValueChange: t,
  max: r,
  min: s,
  value: h = 0,
  label: u,
  inputRef: w,
  isInvalid: a,
  isDisabled: n
}) => {
  const e = Number(h), l = N(
    () => typeof r == "number" && e + 1 > r,
    [r, e]
  ), i = N(
    () => typeof s == "number" && e - 1 < s,
    [s, e]
  ), g = c(() => {
    l || t(e + 1);
  }, [l, t, e]), y = c(() => {
    i || t(e - 1);
  }, [i, t, e]), B = c(
    (b) => {
      const f = b.target.value;
      isNaN(+f) || typeof r == "number" && +f > r || t(+b.target.value);
    },
    [r, t]
  ), d = "rounded-full bg-slate-100 text-foreground hover:bg-blue-100 hover:text-blue active:bg-blue-200 active:text-blue disabled:text-slate-300 disabled:bg-slate-100", { root: M, input: j } = C({ error: a });
  return /* @__PURE__ */ m("div", { className: "flex flex-col", children: [
    u && /* @__PURE__ */ o("p", { className: "mb-2 text-sm font-bold", children: u }),
    /* @__PURE__ */ m(
      "div",
      {
        className: v(
          "flex w-full items-center justify-between focus-within:border-primary-6 focus-visible:outline-none",
          {
            "border-red focus-within:border-red": a,
            "border-border focus-within:border-border": n
          },
          M()
        ),
        children: [
          /* @__PURE__ */ o(
            x,
            {
              size: "icon",
              disabled: i || n,
              onClick: y,
              icon: /* @__PURE__ */ o(p, { name: "Minus" }),
              className: d
            }
          ),
          /* @__PURE__ */ o(
            "input",
            {
              disabled: n,
              ref: w,
              className: v(
                "w-full text-center caret-blue outline-none disabled:bg-transparent disabled:text-slate-400",
                j(),
                "p-0"
              ),
              value: e,
              onChange: B
            }
          ),
          /* @__PURE__ */ o(
            x,
            {
              size: "icon",
              disabled: l || n,
              onClick: g,
              icon: /* @__PURE__ */ o(p, { name: "Plus" }),
              className: d
            }
          )
        ]
      }
    )
  ] });
}, A = k.memo(I);
export {
  A as CounterInput
};
